import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { trackEvent } from '../utils/metaPixel';
export function Offer() {
  return <section id="oferta" className="py-24 bg-white" data-id="element-71">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-cream rounded-[40px] p-10 lg:p-16 text-center shadow-lg border border-beige relative overflow-hidden" data-id="element-73">
          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-64 h-64 bg-sage/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-74" />
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-rose/10 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" data-id="element-75" />

          <div className="relative z-10" data-id="element-76">
            <h2 className="text-3xl lg:text-5xl font-medium text-brown mb-6 leading-tight" data-id="element-77">
              Acceso completo al <br className="hidden lg:block" data-id="element-78" />
              <span className="text-olive" data-id="element-79">Método Piel Clara Natural</span>{' '}
              <br className="hidden lg:block" data-id="element-80" />+ todos los bonos
            </h2>

            <div className="my-10" data-id="element-81">
              <span className="text-6xl lg:text-7xl font-serif font-semibold text-brown" data-id="element-82">
                4,99€
              </span>
              <span className="text-brown/60 ml-2 text-lg" data-id="element-83">pago único</span>
            </div>

            <ul className="space-y-4 mb-12 max-w-md mx-auto text-left" data-id="element-84">
              {['Ebook principal paso a paso', 'Rutina básica de cuidado facial', 'Preparaciones naturales simples', 'Plan práctico', 'Bono: Rutinas según tipo de piel', 'Bono: Lista de ingredientes esenciales', 'Bono: Hábitos clave para tu rutina'].map((item, i) => <li key={i} className="flex items-center gap-3 text-brown/80" data-id="element-85">
                  <CheckCircle2 className="text-sage shrink-0" size={20} data-id="element-86" />
                  <span data-id="element-87">{item}</span>
                </li>)}
            </ul>

            <motion.a href="https://ideasquetransforman.store/products/piel-radiante-en-casa" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
            content_name: 'Método Piel Clara Natural',
            value: 7.99,
            currency: 'EUR'
          })} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-block w-full sm:w-auto bg-sage text-white px-12 py-5 rounded-full text-xl font-medium shadow-md hover:bg-olive transition-colors duration-300 text-center" data-id="element-88">
              Obtener acceso ahora
            </motion.a>
            <p className="mt-4 text-sm text-brown/50 font-light" data-id="element-89">
              Acceso inmediato y de por vida
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}